import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whatsapp-support',
  templateUrl: './whatsapp-support.component.html',
  styleUrls: ['./whatsapp-support.component.scss']
})
export class WhatsappSupportComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
  contactarSoporte(): void {
    const numeroSoporte = '595986665338'; // Número de soporte (tomado del ejemplo encontrado)
    const mensaje = 'Hola, necesito ayuda con el sistema Logistica GTP. ¿Pueden brindarme soporte técnico?';
    const url = `https://wa.me/${numeroSoporte}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  }
}